// extracted by mini-css-extract-plugin
export default {"policies":"policies___pR4lW","policy":"policy___lq4zP","title":"title___s2wy5","pre":"pre___GKjIw","empty":"empty___H3jzm","block":"block___KU6Ps"};